<template>
    <div v-if="isModalOpen(name)">
      <slot :modalName="name" :open="isModalOpen(name)" :active="isModalActive(name)" :data="getModalData(name)"
            :activeId="getActiveModalId(name)"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ModalRoot',
    computed: {
        ...mapGetters('ui', ['isModalOpen', 'isModalActive', 'getModalData', 'getActiveModalId'])
    },
    props: {
        name: {
            type: String
        }
    }
}
</script>

<style lang="scss">

.slide-fade-enter-active {
  transition: all 1s ease-out;
}

.slide-fade-leave-active {
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
